module.exports = __webpack_public_path__ + "static/spinnin_0-35b2ceb60ca3e70ea7ac29f554e61366.jpg";